import $ from 'jQuery';

const $window = $(window);

export function smoothscroll(event, scrollTrigger, selectorToScroll = null) {
    var selector;
    if ($(scrollTrigger).attr('href') != undefined) {
        event.preventDefault();
        selector = $(scrollTrigger).attr('href');
    } else if ($(scrollTrigger).data('selector') != undefined) {
        selector = $(scrollTrigger).data('selector');
    } else {
        if (!selectorToScroll) {
            return;
        }
        selector = selectorToScroll;
    }

    if ($(".advisor-search").length > 0) {
        let regex = /^#advisor\d+$/;
        
        if (regex.test(selector)) {
            let parentRow = $(selector).find('.advisor-list__row');
            let content = $(selector).find('.advisor-list__advisors');
        
            $(selector).find('.advisor-list__rowName_show').addClass('active');
            $(selector).find('.advisor-list__rowName_show').html('skrýt poradce ▲');
            $(content).addClass('active');
            $(parentRow).addClass('active');
        }
    }

    var offset = 100;
    if ($(scrollTrigger).data('offset') != undefined) {
        offset = $(scrollTrigger).data('offset');
    }

    var animationDuration = 500;
    if ($(scrollTrigger).data('animduration') != undefined) {
        animationDuration = $(scrollTrigger).data('animduration');
    }

    $('html, body')
        .stop()
        .animate(
            {
                scrollTop: $(selector).offset().top - offset,
            },
            animationDuration,
            function () {
                $window.trigger('smoothscroll:end');
            }
        );
}

$(function () {
    $(document).on('click', '.smoothscroll', function (event) {
        if (!$(event.target).hasClass('advisor-search__buttonSearch')) {
            smoothscroll(event, this);
        }
    });
});
